export default __webpack_public_path__ + "static/Outfit-Regular-cfc78989d977f1138f4bfc48b4ea9906.woff2";